export default "__VITE_ASSET__fc4bd242__"